import { render, staticRenderFns } from "./nestedTable.vue?vue&type=template&id=42767a0c&scoped=true&"
import script from "./nestedTable.vue?vue&type=script&lang=js&"
export * from "./nestedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42767a0c",
  null
  
)

export default component.exports